class CartAddButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartAddButton = event.target.closest('cart-add-button');
      

      if (cartAddButton) {
        const container = cartAddButton.parentElement;
        console.log("container:", container);
        const values = container.querySelectorAll(".select-rec");
        console.log("values:", values);
        const selectedValues = [];
        values.forEach(selectElement => {
          selectedValues.push(selectElement.value);
        });
        console.log("selectedValues:", selectedValues);
        const scriptElement = container.querySelector('script[type="application/json"][data-product-variants]');
        const productVariants = JSON.parse(scriptElement.textContent);
        const variant = productVariants.find((variant) => {
          return selectedValues.every((value) => variant.options.includes(value));
        });
        
        console.log("variant:", variant.price);
       
        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items') 
        console.log("cartItems:", cartItems);
        let formData = {
            id: variant.id,
            quantity: 1,
          };
         // this.addToCart(formData);
        cartItems.addToCart(formData);
      }
    });
  }
}


document.querySelectorAll('.select-wrapper-custom').forEach(function(selectElement) {
    selectElement.addEventListener('change', function(event) {
        // Find the closest cart-bottom-slider-col container
        const container = selectElement.closest('.cart-bottom-slider-col');
        if (!container) return; // Exit if no container is found

        console.log("Container Found:", container);

        // Get all select values in the same container
        const selectedValues = Array.from(container.querySelectorAll('.select-rec')).map(select => select.value);
        console.log("Selected Values:", selectedValues);

        // Find the script element with product variant data in the same container
        const scriptElement = container.querySelector('script[type="application/json"][data-product-variants]');
        if (!scriptElement) {
            console.error("Script element with product variants not found");
            return; // Exit if no script element is found
        }

        const productVariants = JSON.parse(scriptElement.textContent);
        console.log("Product Variants:", productVariants);

        // Find the matching variant
        const matchingVariant = productVariants.find(variant => 
            selectedValues.every(value => variant.options.includes(value))
        );

        if (matchingVariant) {
            console.log("Matching Variant:", matchingVariant);

            // Format the price using Shopify's money format
            const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD' // Replace with your store's currency code
            }).format(matchingVariant.price / 100); // Assuming Shopify price is in cents
          
            const compareformattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD' // Replace with your store's currency code
            }).format(matchingVariant.compare_at_price / 100); // Assuming Shopify price is in cents
            console.log("Formatted Price:", formattedPrice);

            // Update the closest price element in the same container
            const priceElement = container.querySelector('.upcart-upsell-item-price');
            const comparepriceElement = container.querySelector('.upcart-upsell-item-compare-price');
            if (priceElement) {
                priceElement.textContent = formattedPrice;
                comparepriceElement.textContent = compareformattedPrice;
                console.log("Price updated to:", formattedPrice);
            } else {
                console.error("Price element not found in container");
            }
        } else {
            console.warn("No matching variant found for selected options");
        }
    });
});


customElements.define('cart-add-button', CartAddButton);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, this.dataset.name, null, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class ShippingProtection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', debounce((event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer').querySelector('cart-drawer-items');
      cartItems.shippingProtectionEvent(event);
    }, ON_CHANGE_DEBOUNCE_TIMER));
  }
}
customElements.define('shipping-protection', ShippingProtection);

class UpgradeProduct extends HTMLElement {
  constructor() {
    super();
    const upgrade_buttons = this.querySelectorAll('button');
    upgrade_buttons.forEach((button) => {
      button.addEventListener('click', debounce((event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer').querySelector('cart-drawer-items');
        cartItems.upgradeProduct(button);
      }, ON_CHANGE_DEBOUNCE_TIMER));
    });
  }
}
customElements.define('upgrade-product', UpgradeProduct);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    
    const debouncedOnChange = debounce((event) => {
      if (!event.target.classList.contains('select-rec')) {
        this.onChange(event);
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.shippingProtectionEvent();
    this.upgradeProduct();
    this.initSlider();
    this.recommended_prod();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  
  shippingProtectionEvent(event) {
    if (!event) return;
    
    var shippingProtectionbtn = event.target.classList.contains('ToggleSwitch') ? event.target : event.target.closest('.ToggleSwitch');
    if (shippingProtectionbtn && shippingProtectionbtn.classList.contains('ToggleSwitch')) {
        shippingProtectionbtn.classList.toggle("ToggleSwitch--active");
        shippingProtectionbtn.querySelector(".ToggleSwitch__circle__new").classList.toggle("ToggleSwitch__circle--active");
        var targetElement = shippingProtectionbtn;
        var id = targetElement.getAttribute("data-shipping-id");
        let formData = {
            id: id,
            quantity: 1,
        };
        if (!targetElement.classList.contains("shipping-added")) {
            localStorage.setItem("shippingProtection","ADDED");
            this.addToCart(formData, targetElement);
        } else {
            localStorage.setItem("shippingProtection","REMOVED");
            let remove_btn = document.querySelector('.shipping-product .cart-remove-button');
            
            if(remove_btn){
              const clickEvent = new Event('click', { bubbles: true });
              remove_btn.dispatchEvent(clickEvent); 
            }
        }
    }
  }

  upgradeProduct(button){
    if(button){
      var add_id = button.getAttribute("data-add-id");
      var remove_index = button.getAttribute("data-remove-index");
      var quantity = button.getAttribute("data-quantity");
      var formData = {
          id: add_id,
          quantity: quantity,
      };
      this.removeToCart(button.getAttribute('data-remove-index'),button, 0, formData);
    }
  }
  
  addToCart(formData, targetElement) {
    if(targetElement) targetElement.disabled = true;
    let id = formData.id, quantity = formData.quantity;
      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        window.cartStrings.error = response.errors || response.description;
        this.error = true;
        return;
      }

      if (!this.error){
        this.error = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart.renderContents(response);
        this.recommended_prod();
        this.initSlider();
             const cartDrawerRecommendations = document.querySelector('.cust_rocom_prod');
                if (cartDrawerRecommendations) {
                  const swiperSlides = cartDrawerRecommendations.querySelectorAll('.swiper-slide');
                  if (swiperSlides.length === 0) {
                    cartDrawerRecommendations.innerHTML = '';
                  }
                }
      }
    })
    .catch((e) => {
      console.error(e);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      this.querySelector('.loading__spinner')?.classList.add('hidden');
    });
  }

  removeToCart(line, targetElement, qty, formData = false) {
    let this_item = targetElement.closest('.cart-item');
    if(this_item){
      let spinner = this.querySelector('.cart-item__totals .loading__spinner.hidden');
      if(spinner) spinner.classList.remove('hidden');
    }
    if(targetElement) targetElement.disabled = true;
    const body = JSON.stringify({
      updates: {
        [line]: qty
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        if(formData)
        this.addToCart(formData,targetElement);
      });
  }
  
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index, 
      event.target.value, 
      document.activeElement.getAttribute('name'), 
      event.target.dataset.quantityVariantId,
      event
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.cart-drawer__shipping_protection'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }


  initSlider(){
    let isSliderInitialized = true;
    var cartBottomSliderWrp = new Swiper(".cart-bottom-slider-wrp", {
        slidesPerView: 1,
        spaceBetween: 10,
        slideToClickedSlide: true,
        speed: 800,
        navigation: {
            nextEl: ".cart-bottom-slider-block .swiper-button-next",
            prevEl: ".cart-bottom-slider-block .swiper-button-prev"
        },
        pagination: {
            el: ".cart-bottom-slider-block .swiper-pagination",
            type: "progressbar"
        },
        breakpoints: {
            601: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        }
    });
    
    function initializeSlider(){
        if (window.innerWidth > 749) {
            if (!isSliderInitialized) {
                cartBottomSliderWrp = new Swiper(".cart-bottom-slider-wrp", {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    slideToClickedSlide: true,
                    speed: 800,
                    navigation: {
                        nextEl: ".cart-bottom-slider-block .swiper-button-next",
                        prevEl: ".cart-bottom-slider-block .swiper-button-prev"
                    },
                    pagination: {
                        el: ".cart-bottom-slider-block .swiper-pagination",
                        type: "progressbar"
                    },
                    breakpoints: {
                        601: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                    }
                });
                isSliderInitialized = true;
                //console.log('Swiper initialized');
            }
        } else {
            if (isSliderInitialized) {
                cartBottomSliderWrp.destroy(true, true);
                isSliderInitialized = false;
                //console.log('Swiper destroyed');
            }
        }
    }
    
    initializeSlider();
    window.addEventListener("resize", () => {
        console.log('used window.innerWidth', window.innerWidth);
        initializeSlider();
    });
  }







  
 recommended_prod() {
    var secId = "cart-drawer";
    var cartRecommendationsSection = document.querySelector(`.cart-bottom-slider .container-${secId}`);

    if (cartRecommendationsSection) {
        var cartUrl = cartRecommendationsSection.getAttribute('data-url');

        // Check if cartUrl exists
        if (!cartUrl) {
            console.warn("cartUrl not found. Script will not run.");
            return;
        }

        fetch(cartUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(data => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(data, 'text/html');
                var recommendations = doc.querySelector(`.cart-drawer-recommendations`);

                if (recommendations) {
                    cartRecommendationsSection.innerHTML = recommendations.innerHTML;
                    var custRecomElements = document.querySelectorAll('.cust_recom');
                    document.querySelector('.cart-drawer-recommendations').innerHTML = recommendations.innerHTML;
                    this.initSlider();
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }
}

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, event, formData) {
    this.enableLoading(line, name, event);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        if(parsedState.item_count === 0 && localStorage.getItem("shippingProtection") == 'ADDED'){
          localStorage.removeItem("shippingProtection");
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        if (formData) {
          this.addToCart(formData);
        } else {
          const cart_wrapper = document.querySelector('cart-items') || document.querySelector('cart-drawer-items'),
                dataIndex = cart_wrapper.querySelector(".cart-item.shipping-product");
          if(dataIndex && parsedState.item_count === 1){
            let remove_btn = dataIndex.querySelector('.cart-remove-button');
            if(remove_btn){
              const clickEvent = new Event('click', { bubbles: true });
              remove_btn.dispatchEvent(clickEvent); 
            }
          }
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line,name);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const cartDrawerRecommendations = document.querySelector('.cust_rocom_prod');
  if (cartDrawerRecommendations) {
    const swiperSlides = cartDrawerRecommendations.querySelectorAll('.swiper-slide');
    if (swiperSlides.length === 0) {
      cartDrawerRecommendations.innerHTML = '';
    }
  }
});